import { useState } from "react";
import { ShareIcon } from "../../images";
import { ShareCampaignModal } from "../modal";
import { CircularProgress } from "@mui/material";
import { useLazyGetUsersThatShareCampaignQuery } from "../../../api";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../hooks";
import { selectPermissions } from "../../../features/permissionsSlice";
import { ReuseButton } from "../ReuseButton";

export const ShareCampaignBtn = ({ userEmail }: { userEmail: string }) => {
  const { campaign_id } = useParams();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isAllowedShareAccess } = useAppSelector(selectPermissions);

  const [
    getUsersThatShareCampaign,
    { data: sharedCampaignUsers, isFetching: isUserLoading },
  ] = useLazyGetUsersThatShareCampaignQuery();

  const openHandler = () => {
    if (!campaign_id) return;
    getUsersThatShareCampaign(campaign_id)
      .unwrap()
      .then(() => setIsOpen(true));
  };

  return (
    <>
      <ReuseButton
        onClick={openHandler}
        startIcon={
          isUserLoading ? (
            <CircularProgress size={24} sx={{ color: "inherit" }} />
          ) : (
            <ShareIcon />
          )
        }
        disabled={isUserLoading || !isAllowedShareAccess}
        sx={{ height: "40px" }}
      >
        Share
      </ReuseButton>
      {isOpen && sharedCampaignUsers && (
        <ShareCampaignModal
          userEmail={userEmail}
          sharedCampaignUsers={sharedCampaignUsers}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  );
};
